import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { HttpHeaders } from "@angular/common/http";
import { lastValueFrom } from "rxjs";
import { TableAction } from "src/app/shared/components/table-paginator/table-paginator.component";
import { FlujoService } from "src/app/core/services/flujos.service";
import { ServiciosService } from "src/app/core/services/servicios.service";
import Swal, { SweetAlertIcon } from "sweetalert2";
import { k } from "src/environments/properties";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "src/app/core/services/AuthService";

interface Item {
  id: number;
  nombre: string;
  descripcion: string;
  endpoint: string;
}

@Component({
  selector: "app-list-flujo",
  templateUrl: "./list-flujo.component.html",
  styleUrls: ["./list-flujo.component.scss"],
})
export class ListFlujoComponent implements OnInit {
  fullData: Item[] = []; // Tu conjunto completo de datos
  currentItems: Item[] = []; // Los datos para la página actual

  currentPage: number = 1;
  pageSize: number = 10; // Tamaño de página inicial
  totalItems: number = 0;
  spinner: boolean;

  tableHeaders = [
    { key: "nombre", label: "Nombre" },
    { key: "descripcion", label: "Descripción" },
    { key: "endpoint", label: "Endpoint" },
  ];

  // Definición de las acciones personalizadas
  customActions: TableAction[] = [];

  //Manejo de grupos del usuario
  idBucketP: number;
  defaultBucket: number | null = null;

  //MODAL
  public closeResult: string;
  private modalRef?: NgbModalRef;
  @ViewChild("createUser") referencecreateUser!: TemplateRef<any>;

  title = "";

  addUser: boolean = false;
  udpUser: boolean = false;
  idUser: string;

  // Toast
  toast = Swal;
  user: any;

  constructor(
    private flujoservice: FlujoService,
    private Servicioservice: ServiciosService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {
    this.user = localStorage.getItem(k.user_id) ?? "";
  }

  async ngOnInit() {
    //this.initSearchForm();
    this.toastAlert();
    await this.getDefaultBucket();
    await this.getFlujos();

    // Configura las acciones personalizadas
    this.customActions = [
      {
        label: "Editar",
        handler: (item: Item) => this.showUser(item.id),
        icon: "fa-solid fa-pen-to-square",
        colorClass: "bg-orange",
      },
      {
        label: "Predeterminado",
        handler: (item: Item) => this.selectDefault(item),
        icon: (item: Item) => {
          return item.id === this.defaultBucket
            ? "fa-solid fa-circle-check"
            : "fa-solid fa-star";
        },
        colorClass: (item: Item) => {
          return item.id === this.defaultBucket ? "bg-green" : "bg-blue";
        },
      },
      {
        label: "Eliminar",
        handler: (item: Item) =>  this.deleteFlujo(item)  ,
        icon: "fa-solid fa-trash-can",
        colorClass: "bg-danger text-white",
        visible: (item: any) => {
            return item.id !== this.defaultBucket && this.authService.hasRoleAuth('ADMINISTRADOR')
        }
      }
    ];
  }

  toastAlert() {
    this.toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  }

    async deleteFlujo(item: any) {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta acción eliminará el registro y no se podrá deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#dc3545',
        reverseButtons: true,
      });
  
      if (!result.isConfirmed) {
        return;
      }
  
      try {
        await lastValueFrom(
          this.Servicioservice.deleteFlujo(
            item?.idServicioExterno,
            item?.id
          )
        );
  
        await Swal.fire({
          title: 'Eliminado',
          text: 'El registro se eliminó correctamente.',
          icon: 'success',
          confirmButtonText: 'Aceptar',
        });
        
        await this.getFlujos();
  
      } catch (error) {      
  
        await Swal.fire({
          title: 'Error',
          text: 'No se pudo eliminar el registro.',
          icon: 'error',
          confirmButtonText: 'Aceptar',
        });
      }
    }
  

  async getDefaultBucket() {
    const idServicio = this.route.snapshot.paramMap.get("id");

    const servicioResponse = await lastValueFrom(
      this.Servicioservice.showServicios(idServicio),
    );

    this.defaultBucket = Number(
      servicioResponse.body?.idServicioExternoFlujoPredeterminado ?? null,
    );
  }

  async showUser(id: any) {
    this.idBucketP = id;
    this.openModal(this.referencecreateUser, "edit", "Editar Flujo");
  }

  async selectDefault(registro: any) {
    const nombre_flujo = registro.nombre;

    const result = await Swal.fire({
      title: "Confirmación",
      text: `¿Deseas seleccionar ${nombre_flujo} como flujo predeterminado`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      const idServicio = this.route.snapshot.paramMap.get("id");

      const payload = {
        id_servicio_externo_flujo_predeterminado: registro.id,
      };

      await lastValueFrom(
        this.Servicioservice.editarServicio(payload, idServicio),
      );

      this.defaultBucket = registro.id;
      this.modalRef?.close(true);
      await this.getFlujos();

      this.alert(
        "success",
        "Flujo actualizado",
        `${nombre_flujo} ahora es el flujo predeterminado.`,
      );
    } catch (error) {
      console.error("Error al seleccionar bucket predeterminado:", error);

      this.alert(
        "error",
        "Error",
        "No fue posible seleccionar el flujo predeterminado.",
      );
    }
  }

  async saved(response: any): Promise<void> {
    this.modalRef?.close(response);

    await this.getFlujos();
    await this.getDefaultBucket();
  }

  closeModal(){
    this.modalRef?.close();
  }

  alert(icontext: SweetAlertIcon, title: string, text: string = "") {
    this.toast.fire({
      icon: icontext,
      title: title,
      text: text,
    });
  }

  openModal(content: any, action: string, title: string) {
    this.title = title;

    if (action === "add") {
      this.addUser = true;
      this.udpUser = false;
    } else {
      this.addUser = false;
      this.udpUser = true;
    }

    this.modalRef = this.modalService.open(content, {
      ariaLabelledBy: "modal-basic-title",
      size: "lg",
    });

    this.modalRef.result.then(
      (result) => {
        this.idBucketP = 0;
        this.closeResult = `Closed with: ${result}`;
        this.modalRef = undefined;
      },
      (reason) => {
        this.idBucketP = 0;
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.modalRef = undefined;
      },
    );
  }

  /*
   FUNCIONES PARA EL MODAL
  */
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  async searchUser() {
    this.currentPage = 1;
    this.getFlujos();
  }

  async getFlujos(response = null) {
    if (response !== null) {
      this.defaultBucket = response.id;
    }
    this.spinner = true;
    const idServicio = this.route.snapshot.paramMap.get("id");

    //const search = this.searchForm.value.search;
    const result = await lastValueFrom(
      this.flujoservice.getFlujos(
        idServicio,
        this.currentPage,
        this.pageSize,
        //  search,
      ),
    );

    const headers: HttpHeaders = result.headers;
    this.spinner = false;
    this.currentItems = result.body.map((x: any, index: number) => {
      return {
        id: x.id,
        nombre: x.nombre,
        descripcion: x.descripcion,
        endpoint: x.endpoint,
      };
    });
    this.totalItems = Number(headers.get("X-Total-Count"));
  }

  onPageChange(newPage: number): void {
    this.currentPage = newPage;
    this.getFlujos();
  }

  onPageSizeChange(newSize: number): void {
    this.pageSize = newSize;
    this.currentPage = 1; // Siempre vuelve a la primera página al cambiar el tamaño
    this.getFlujos();
  }
}
